import React from 'react';
import GeneralInfo from './GeneralInfo';

export default class AccountCard extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log('AccountCard - Props', this.props);
		return (
			<div className="AccountCard">
				<div className="card">
					<div className="card-body">
						<section>
							<h1 className="card-title">{this.props.account_endpoint.name}</h1>
						</section>
						<GeneralInfo
							data={{
								name_label: 'Label',
								name_value: 'Content',
								email_label: 'Label',
								email_value: 'Content',
								status_label: 'Label',
								status_value: 'Content',
								address_label: 'Label',
								address_value: 'Content',
								birthday_label: 'Label',
								birthday_value: 'Content'
							}}
						/>
						<GeneralInfo
							data={{
								name_label: 'Label',
								name_value: 'Content',
								email_label: 'Label',
								email_value: 'Content',
								status_label: 'Label',
								status_value: 'Content',
								address_label: 'Label',
								address_value: 'Content',
								birthday_label: 'Label',
								birthday_value: 'Content'
							}}
						/>
						<GeneralInfo
							data={{
								name_label: 'Label',
								name_value: 'Content',
								email_label: 'Label',
								email_value: 'Content',
								status_label: 'Label',
								status_value: 'Content',
								address_label: 'Label',
								address_value: 'Content',
								birthday_label: 'Label',
								birthday_value: 'Content'
							}}
						/>
					</div>
				</div>
			</div>
		);
	}
}
